
import { Box, Text, Flex, Icon } from "@chakra-ui/react";
import { FaArrowUp, FaArrowDown, FaEquals } from "react-icons/fa";
import SystematicFactorsStackedAreaChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsStackedAreaChart";
import SystematicFactorsStackedBarChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsStackedBarChart";
import SystematicFactorsLineChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsLineChart";
import BlurSection from "../../../shared/BlurSection/BlurSection";
import { useSelector } from "react-redux";


const TrendIndicator = ({ direction }) => {
  switch (direction) {
    case "up":
      return <Icon as={FaArrowUp} color="green.500" />;
    case "down":
      return <Icon as={FaArrowDown} color="red.500" />;
    default:
      return <Icon as={FaEquals} color="gray.500" />;
  }
};


const ObservationText = ({ observation }) => {
  if (!observation || observation.percentage === 0) {
    return <Text fontSize="sm" color="gray.500">No observation data available</Text>;
  }

  return (
    <Flex align="center" gap={2}>
      <TrendIndicator direction={observation.direction} />
      <Text fontSize="sm">
        Observed {observation.trend} of {observation.percentage}% over {observation.percentage === 100 ? "all" : `${observation.percentage}/7`} years
      </Text>
    </Flex>
  );
};

const Finance = ({ graphData, isAuthenticatedUser, observations }) => {
  const smeActivityModule = useSelector(
    (state) => state.userModuleReducer?.data?.["SME Activity"] ?? {}
  );

  const renderChartBox = (dataKey, ChartComponent, heading) => (
    <Box w="100%" mb={6} position="relative">
 
      <Box
        position="absolute"
        top="2"
        right="2"
        zIndex="1"
        bg="whiteAlpha.800"
        px="2"
        borderRadius="md"
        style={{
          filter: isAuthenticatedUser ? "none" : "blur(3px)",
          pointerEvents: isAuthenticatedUser ? "auto" : "none",
          transition: "filter 0.3s ease",
        }}
      >
        <ObservationText observation={observations?.[dataKey]} />
      </Box>

    
      <ChartComponent
        data={graphData[dataKey]}
        heading={heading}
        dimension={{ width: "100%", height: "230px" }}
      />

   
      {smeActivityModule?.[heading]?.showBlur && <BlurSection height={"80%"} width={"25%"} />}
    </Box>
  );

  return (
    <>
      {renderChartBox("totalWorkingCapital", SystematicFactorsStackedAreaChart, "Total Working Capital")}
      {renderChartBox("totalFinancialAssets", SystematicFactorsStackedBarChart, "Total Financial Assets")}
      {renderChartBox("totalInterest", SystematicFactorsLineChart, "Total Interest")}
      {renderChartBox("totalTax", SystematicFactorsStackedAreaChart, "Total Tax")}
      {renderChartBox("totalDebt", SystematicFactorsStackedBarChart, "Total Debt")}
      {renderChartBox("totalShareholdersEquity", SystematicFactorsStackedAreaChart, "Total Shareholders Equity")}
    </>
  );
};

export default Finance;
